import { useState } from 'react'
import {
  Button,
  Grid,
  Input,
  Modal,
  Spinner,
} from '@enterprise-ui/canvas-ui-react'
import EnterpriseIcon, { SaveIcon, TrashIcon } from '@enterprise-ui/icons'
import { TextFilter } from '../../globalComponents/TextFilter'

export const SaveViewModal = (props) => {
  const {
    renderPopup,
    modalOnClick,
    modalOnClickSaveAs,
    waitingOnSaveViewModal,
    onClose,
    modalType,
    saveViewName,
  } = props

  const [viewName, setViewName] = useState(saveViewName)
  const [radioSelection, setRadioSelection] = useState('Save')

  const isOverCharLimit = () => {
    if (viewName.length > 35) {
      return true
    }
    return false
  }

  const containsSpecialChars = () => {
    let alphaNumeric = /^[a-z0-9 ]+$/i
    if (viewName && !alphaNumeric.test(viewName)) {
      return true
    }
  }

  const isEmptyName = () => {
    let emptyString = /^\s*$/
    if (emptyString.test(viewName)) {
      return true
    }
  }

  const validateInput = () => {
    if (isOverCharLimit()) {
      return false
    } else if (containsSpecialChars()) {
      return false
    } else if (isEmptyName()) {
      return false
    }
    return true
  }

  return (
    <>
      {modalType === 'Save' && (
        <Modal
          headingText="Save View"
          isVisible={renderPopup}
          onRefuse={() => onClose()}
          size="dense"
          data-testid="save-view-modal"
        >
          {waitingOnSaveViewModal ? (
            <Grid.Item
              className="hesp-general-flex"
              style={{ padding: '12px' }}
            >
              <Spinner
                data-testid="saved-view-loading"
                className="hesp-general-marginAuto hesp-general-justifyCenter"
                size="expanded"
              />
            </Grid.Item>
          ) : (
            <>
              {' '}
              <div className="hc-ph-md">
                <TextFilter
                  data-testid="save-view-textfilter"
                  label="View Name"
                  onChange={(event) => setViewName(event.target.value)}
                  value={viewName}
                  error={
                    isOverCharLimit(viewName) || containsSpecialChars(viewName)
                  }
                  errorText={`${
                    isOverCharLimit(viewName)
                      ? 'Text limit is 35 characters.'
                      : ''
                  } ${
                    containsSpecialChars(viewName)
                      ? 'No special characters.'
                      : ''
                  }`}
                  required
                ></TextFilter>
              </div>
              <div
                className="hc-ph-lg hc-pb-lg hesp-general-flex hesp-general-flex-direction-reverse"
                style={{ gap: '4px' }}
              >
                <Button
                  data-testid="save-view-button"
                  type="secondary"
                  onClick={(e) => {
                    modalOnClick(viewName)
                    setViewName('')
                  }}
                  disabled={!viewName || !validateInput()}
                >
                  <EnterpriseIcon icon={SaveIcon} />
                  Save View
                </Button>
                <Button type="ghost" onClick={() => onClose()}>
                  Cancel
                </Button>
              </div>{' '}
            </>
          )}
        </Modal>
      )}
      {modalType === 'Update' && (
        <Modal
          headingText="Save View"
          isVisible={renderPopup}
          onRefuse={() => {
            onClose()
          }}
          size="dense"
          data-testid="save-view-modal"
        >
          {waitingOnSaveViewModal ? (
            <Grid.Item
              className="hesp-general-flex"
              style={{ padding: '12px' }}
            >
              <Spinner
                data-testid="saved-view-loading"
                className="hesp-general-marginAuto hesp-general-justifyCenter"
                size="expanded"
              />
            </Grid.Item>
          ) : (
            <>
              <div className="hc-ph-md">
                <Input.Radio
                  data-testid="save-view-radio"
                  id="save_view_radio"
                  options={[
                    {
                      label: 'Save',
                      value: 'Save',
                    },
                    {
                      label: 'Save As',
                      value: 'SaveAs',
                    },
                  ]}
                  onUpdate={(id, value) => {
                    if (value === 'SaveAs') {
                      setViewName('')
                      setRadioSelection(value)
                    } else {
                      setViewName(saveViewName)
                      setRadioSelection(value)
                    }
                  }}
                  value={radioSelection}
                />
              </div>
              {radioSelection === 'SaveAs' && (
                <div className="hc-ph-md hc-pa-normal">
                  <TextFilter
                    data-testid="save-view-textfilter"
                    label="View Name"
                    onChange={(event) => setViewName(event.target.value)}
                    value={viewName}
                    error={
                      isOverCharLimit(viewName) ||
                      containsSpecialChars(viewName)
                    }
                    errorText={`${
                      isOverCharLimit(viewName)
                        ? 'Text limit is 35 characters.'
                        : ''
                    } ${
                      containsSpecialChars(viewName)
                        ? 'No special characters.'
                        : ''
                    }`}
                    required
                  ></TextFilter>
                </div>
              )}
              <div
                className="hc-ph-lg hc-pb-lg hesp-general-flex hesp-general-flex-direction-reverse"
                style={{ gap: '4px' }}
              >
                <Button
                  data-testid="save-view-button"
                  type="secondary"
                  onClick={(e) => {
                    radioSelection === 'SaveAs'
                      ? modalOnClickSaveAs(viewName)
                      : modalOnClick(viewName)
                  }}
                  disabled={!viewName || !validateInput()}
                >
                  <EnterpriseIcon icon={SaveIcon} />
                  Save View
                </Button>
                <Button type="ghost" onClick={() => onClose()}>
                  Cancel
                </Button>
              </div>
            </>
          )}
        </Modal>
      )}
      {modalType === 'Delete' && (
        <Modal
          headingText="Delete Saved View"
          isVisible={renderPopup}
          onRefuse={() => onClose()}
          size="dense"
          data-testid="save-view-modal"
        >
          {waitingOnSaveViewModal ? (
            <Grid.Item
              className="hesp-general-flex"
              style={{ padding: '12px' }}
            >
              <Spinner
                data-testid="save-view-loading"
                className="hesp-general-marginAuto hesp-general-justifyCenter"
                size="expanded"
              />
            </Grid.Item>
          ) : (
            <>
              <div className="hc-ph-md hc-pb-lg">
                Are you sure you want to delete this saved view?
              </div>
              <div
                className="hc-ph-lg hc-pb-lg hesp-general-flex hesp-general-flex-direction-reverse"
                style={{ gap: '4px' }}
              >
                <Button
                  data-testid="delete-view-button"
                  type="destructive"
                  onClick={() => modalOnClick(viewName)}
                >
                  <EnterpriseIcon icon={TrashIcon} />
                  Delete Saved View
                </Button>
                <Button type="ghost" onClick={() => onClose()}>
                  Cancel
                </Button>
              </div>
            </>
          )}
        </Modal>
      )}
    </>
  )
}
